import * as React from 'react';
import * as HistoryModule from 'Modules/HistoryModule';
import * as POIModule from 'Modules/POIModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import { connect } from 'react-redux';
import { withTranslation  } from 'react-i18next';

type ToggleAddingZonesBtnP = {
    addingActive: boolean;
    zoneActive: HistoryModule.EnumTypes.ZonesViewType;
    t?: (key: string) => string;
};
type DispatchedProps = {
    showAddingAOI: Function;
    hideAddingAOI: Function;
    showAddingPOI: () => void;
    hideAddingPOI: () => void;
    hideAddingAOIandWipeCoords: Function;
    addPoiPopupPosition: (popupPosition: { lat: number; lng: number }) => void;
    hideAddingPOIAndWipeCoords: () => void;
};

// export const ToggleAddingZonesBtn = (props: ToggleAddingZonesBtnP & DispatchedProps) => {
class ToggleAddingZonesBtn extends React.PureComponent<ToggleAddingZonesBtnP & DispatchedProps> {
    public render() {
        const {addingActive, showAddingAOI, hideAddingAOIandWipeCoords, hideAddingPOIAndWipeCoords, showAddingPOI} = this.props;
        if (this.props.zoneActive === HistoryModule.EnumTypes.ZonesViewType.AOI) {
            return (
                <button onClick={() => (addingActive ? hideAddingAOIandWipeCoords() : showAddingAOI())}
                        className={`btn btn--zones_add btn--blue`}>
                    {addingActive ? this.props.t('cancelAdding') : this.props.t('addZone')}
                </button>
            );
        } else if (this.props.zoneActive === HistoryModule.EnumTypes.ZonesViewType.POI) {
            return (
                <button onClick={() => (addingActive ? hideAddingPOIAndWipeCoords() : showAddingPOI())}
                        className={`btn btn--zones_add btn--blue`}>
                    {addingActive ? this.props.t('cancelAdding') : this.props.t('addPOI')}
                </button>
            );
        }
    }
};
function mapStateToProps(state: any) {
    return {
        aoiStore: state.aoiStore
    };
}
function mapDispachToProps(dispatch: any): DispatchedProps {
    return {
        showAddingAOI: () => dispatch(ViewManagementModule.Actions.showAddingAOI()),
        hideAddingAOI: () => dispatch(ViewManagementModule.Actions.hideAddingAOI()),
        showAddingPOI: () => dispatch(ViewManagementModule.Actions.showAddingPOI()),
        hideAddingPOI: () => dispatch(ViewManagementModule.Actions.hideAddingPOI()),
        hideAddingAOIandWipeCoords: () => dispatch(ViewManagementModule.Actions.hideAddingAOIandWipeCoords()),
        hideAddingPOIAndWipeCoords: () => dispatch(ViewManagementModule.Actions.hideAddingPOIAndWipeCoords()),
        addPoiPopupPosition: (popupPosition: { lat: number; lng: number }) => dispatch(POIModule.Actions.addPoiPopupPosition(popupPosition))
    };
}

export default withTranslation ('forms')(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(ToggleAddingZonesBtn) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Map/MapHelpers/ToggleAddingZonesBtn.tsx